import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { FetchInstallationsContentRequestData } from "./FetchInstallationsContentCommand";

const ENDPOINT = "/cash_flow/content/download";

export class DownloadCashContentReportCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: FetchInstallationsContentRequestData = null;

    constructor(exportType: string, payload: FetchInstallationsContentRequestData) {
        super();
        this.payload = payload;
        this.responseType = "blob";
        this.endPoint = this.endPoint + "/" + exportType;
    }

    public async execute(): Promise<AxiosResponse> {
        return await this.executeCommand(this.payload);
    }
}
